export type AccountPage = 'register' | 'forgotPassword' | 'verifyEmail' | 'resetPassword'

// verifyEmail and resetPassword are fixed by StructuraMatrix.Auth: its e-mails link to <BaseUrl><path>?token=<token>.
export const ACCOUNT_PATHS: Readonly<Record<AccountPage, string>> = {
  register: '/account',
  forgotPassword: '/account/forgot-password',
  verifyEmail: '/verifiser-epost',
  resetPassword: '/tilbakestill-passord',
}

export const LINK_TOKEN_PARAMETER: string = 'token'
